import { get, getAll } from "@/network/rest";
import Locations from "@/network/locations";
import { getActiveBranch, getActiveCompany } from "@/helpers/storage";

const log = (msg, silent = false) => {
  if (!silent) console.log(`${msg} synced`);
};

const getCompany = async (model, accessToken, where, companyId) => {
  const companyRequest = await get(accessToken, `${where}/${companyId}`);
  const company = new model(companyRequest.data);

  log(company.slug);
};

const _getUser = async (model, accessToken, where, userId) => {
  const userRequest = await get(accessToken, `${where}/${userId}`);
  const user = new model(userRequest.data);
};

const _queryUserGeneral = async (
  model,
  accessToken,
  where,
  query,
  companyId
) => {
  let result;

  const userRequest = await get(
    accessToken,
    `${where}?${new URLSearchParams(query).toString()}&customerOf=${companyId}`
  );

  if (userRequest.data.data.length) {
    result = new model(userRequest.data.data[0]);
  }

  return result;
};

const queryUserGeneral = async (feathers, accessToken, querys, companyId) => {
  const { User } = feathers;
  const { customers } = Locations;

  const result = await _queryUserGeneral(
    User,
    accessToken,
    customers,
    querys,
    companyId
  );

  return result;
};

const _queryUserExternalId = async (
  model,
  accessToken,
  where,
  externalId,
  companyId
) => {
  let result;

  const userRequest = await get(
    accessToken,
    `${where}?externalId=${externalId}&customerOf=${companyId}`
  );

  if (userRequest.data.data.length) {
    result = new model(userRequest.data.data[0]);
  }

  return result;
};

const queryUserExternalId = async (
  feathers,
  accessToken,
  externalId,
  companyId
) => {
  const { User } = feathers;
  const { customers } = Locations;

  const result = await _queryUserExternalId(
    User,
    accessToken,
    customers,
    externalId,
    companyId
  );

  return result;
};

const _queryUserCpf = async (model, accessToken, where, cpf, companyId) => {
  let result;
  const cpfFormated = cpf.replace(/\D/g, "");
  const userRequest = await get(
    accessToken,
    `${where}?$or[0][cpf]=${cpf}&$or[1][cpf]=${cpfFormated}&customerOf=${companyId}`
  );

  if (userRequest.data.data.length) {
    result = new model(userRequest.data.data[0]);
  }

  return result;
};

const queryUserCpf = async (feathers, accessToken, cpf, companyId) => {
  const { User } = feathers;
  const { customers } = Locations;

  const result = await _queryUserCpf(
    User,
    accessToken,
    customers,
    cpf,
    companyId
  );

  return result;
};

const _queryLoyaltyCpf = async (model, accessToken, where, cpf, companyId) => {
  let result;

  const loyaltyRequest = await get(
    accessToken,
    `${where}?cpf=${cpf}&company=${companyId}`
  );

  if (loyaltyRequest.data.data.length) {
    result = new model(loyaltyRequest.data.data[0]);
  }

  return result;
};

const queryLoyaltyCpf = async (feathers, accessToken, cpf, companyId) => {
  const { Loyalty } = feathers;
  const { loyalty } = Locations;

  const result = await _queryLoyaltyCpf(
    Loyalty,
    accessToken,
    loyalty,
    cpf,
    companyId
  );

  return result;
};

const getUser = async (feathers, accessToken, userId) => {
  const { User } = feathers;
  const { customers } = Locations;

  await _getUser(User, accessToken, customers, userId);

  return true;
};

const getComplementGroup = async (feathers, accessToken, groupId) => {
  const { ComplementGroup } = feathers;
  const { complementsGroups } = Locations;

  const complementRequest = await get(
    accessToken,
    `${complementsGroups}/${groupId}`
  );
  const complement = new ComplementGroup(complementRequest.data);

  return true;
};

const genericRequest = async (
  model,
  accessToken,
  companyId,
  where,
  branchId,
  minTime,
  silent = false,
  customQuery
) => {
  const all = await getAll(accessToken, companyId, where, branchId, minTime, customQuery);

  if (all === null) throw `erro ao sincronizar ${where}`;

  all.forEach((one) => new model(one));

  log(where, silent);

  return true;
};

const populateCompany = async (feathers, accessToken, companyId) => {
  const { Company, Branch } = feathers;
  const { companies, branches } = Locations;

  await getCompany(Company, accessToken, companies, companyId);
  await genericRequest(Branch, accessToken, companyId, branches);

  log("company all");

  return true;
};

const populateUsers = async (feathers, accessToken, companyId, branchId) => {
  const { User } = feathers;
  const { users } = Locations;

  await genericRequest(User, accessToken, companyId, users, branchId);

  log("users");

  return true;
};

const populateOrders = async (
  feathers,
  accessToken,
  companyId,
  branchId,
  hours,
  silent = false
) => {
  const { Order } = feathers;
  const { orders } = Locations;
  const minTime = hours ? hours * 60 * 60 * 1000 : 12 * 60 * 60 * 1000;

  await genericRequest(
    Order,
    accessToken,
    companyId,
    orders,
    branchId,
    new Date().getTime() - minTime,
    silent
  );

  log("orders", silent);

  return true;
};


const populateScheduledOrders = async (
  feathers,
  accessToken,
  companyId,
  branchId,
  hours,
  silent = false
) => {
  const { Order } = feathers;
  const { orders } = Locations;
  const customQuery = "&scheduledOrder.scheduled=true&status[$nin][]=8&status[$nin][]=16&status[$nin][]=32"

  await genericRequest(
    Order,
    accessToken,
    companyId,
    orders,
    branchId,
    hours,
    silent,
    customQuery
  );

  log("orders scheduled", silent);

  return true;
};



const populateBranch = async (feathers, accessToken, companyId, branchId) => {
  const { ProductCategory, ComplementGroup, Period, Product } = feathers;
  const {
    productsCategories,
    complementsGroups,
    periods,
    products,
  } = Locations;

  await genericRequest(
    ProductCategory,
    accessToken,
    companyId,
    productsCategories,
    branchId
  );

  await genericRequest(
    ComplementGroup,
    accessToken,
    companyId,
    complementsGroups,
    branchId
  );

  await genericRequest(Period, accessToken, companyId, periods, branchId);

  await genericRequest(Product, accessToken, companyId, products, branchId);

  log("initial state all");

  return true;
};

const query = () => ({
  company: getActiveCompany(),
  branch: getActiveBranch(),
});

export {
  populateCompany,
  populateBranch,
  populateOrders,
  populateScheduledOrders,
  populateUsers,
  getUser,
  getComplementGroup,
  query,
  queryUserGeneral,
  queryUserExternalId,
  queryUserCpf,
  queryLoyaltyCpf,
};
